import { useContext as t } from "react";
const d = (e, o) => () => {
  const r = t(e);
  if (r === null)
    throw new Error(
      `"${o}" context is not provided or hook used outside of the "${o}" provider`
    );
  return r;
};
export {
  d as createUseProvidedContext
};
//# sourceMappingURL=index174.mjs.map
